import { render } from "./PrivacyPolicy.vue?vue&type=template&id=8ca44358&scoped=true&ts=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=8ca44358&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ca44358"]])

export default __exports__